// extracted by mini-css-extract-plugin
export default {"searchWrap":"styles_searchWrap__ucYwk","collapsedSearch":"styles_collapsedSearch__XUyX2","searchInput":"styles_searchInput__-T6U2"};